import useEventState from "./useEventState";

export const useChain = () => useEventState("chainChanged", global.chainId);
export const useProvider = () => useEventState("providerChanged", global.provider);
export const useSigner = () => useEventState("signerChanged", global.signer);
export const useWallet = () => useEventState("walletChanged", global.wallet);
